<template>
  <div class="business-cooperation">
    <div class="page-header">
      <el-page-header @back="$router.go(-1)">
        <template #content>
          <div class="page-title">商务合作</div>
        </template>
      </el-page-header>
    </div>

    <!-- Banner Section -->
    <div class="cooperation-banner">
      <div class="banner-overlay">
        <h1 class="banner-title">共创未来<br>携手并进</h1>
        <p class="banner-subtitle">DeePark 诚邀各界伙伴共同打造智慧停车生态</p>
      </div>
    </div>

    <!-- Cooperation Types Section -->
    <div class="cooperation-section">
      <h2 class="section-title">合作模式</h2>
      <div class="cooperation-types">
        <el-card v-for="type in cooperationTypes" :key="type.id" class="type-card" shadow="hover"
                 @click="goToCooperationPage(type.id)">
          <div class="type-icon">
            <el-icon><component :is="type.icon"></component></el-icon>
          </div>
          <h3 class="type-title">{{ type.title }}</h3>
          <p class="type-desc">{{ type.description }}</p>
        </el-card>
      </div>
    </div>

    <!-- Benefits Section -->
    <div class="cooperation-section benefits-section">
      <h2 class="section-title">合作优势</h2>
      <div class="benefits-list">
        <div v-for="(benefit, index) in benefits" :key="index" class="benefit-item">
          <div class="benefit-number">{{ index + 1 }}</div>
          <div class="benefit-content">
            <h3 class="benefit-title">{{ benefit.title }}</h3>
            <p class="benefit-desc">{{ benefit.description }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Case Studies Section -->
    <div class="cooperation-section">
      <h2 class="section-title">成功案例</h2>
      <el-carousel :interval="4000" type="card" height="200px" indicator-position="outside">
        <el-carousel-item v-for="(case_study, index) in caseStudies" :key="index">
          <div class="case-card" :style="{ backgroundImage: `url(${case_study.image})` }">
            <div class="case-overlay">
              <div class="case-content">
                <div class="case-logo">
<!--                  <img :src="case_study.logo" :alt="case_study.partner" class="partner-logo">-->
                </div>
                <h3 class="case-title">{{ case_study.title }}</h3>
                <div class="case-partner">{{ case_study.partner }}</div>
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>

    <!-- Contact Form Section -->
    <div class="cooperation-section form-section">
      <h2 class="section-title">合作咨询</h2>
      <p class="form-subtitle">填写以下信息，我们的商务团队将尽快与您联系</p>
      
      <el-form 
        ref="contactForm" 
        :model="formData" 
        :rules="formRules" 
        label-position="top"
        class="contact-form"
      >
        <el-form-item label="公司名称" prop="company">
          <el-input v-model="formData.company" placeholder="请输入您的公司名称"></el-input>
        </el-form-item>
        
        <el-form-item label="姓名" prop="name">
          <el-input v-model="formData.name" placeholder="请输入您的姓名"></el-input>
        </el-form-item>
        
        <el-form-item label="职位" prop="position">
          <el-input v-model="formData.position" placeholder="请输入您的职位"></el-input>
        </el-form-item>
        
        <el-form-item label="联系电话" prop="phone">
          <el-input v-model="formData.phone" placeholder="请输入您的联系电话"></el-input>
        </el-form-item>
        
        <el-form-item label="电子邮箱" prop="email">
          <el-input v-model="formData.email" placeholder="请输入您的电子邮箱"></el-input>
        </el-form-item>
        
        <el-form-item label="合作意向" prop="interest">
          <el-select v-model="formData.interest" placeholder="请选择合作意向" style="width: 100%">
            <el-option 
              v-for="type in cooperationTypes" 
              :key="type.id" 
              :label="type.title" 
              :value="type.id"
            ></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="需求描述" prop="description">
          <el-input 
            v-model="formData.description" 
            type="textarea" 
            :rows="4" 
            placeholder="请简要描述您的合作需求和期望"
          ></el-input>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" class="submit-button" @click="submitForm">提交咨询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- FAQ Section -->
    <div class="cooperation-section faq-section">
      <h2 class="section-title">常见问题</h2>
      
      <el-collapse>
        <el-collapse-item v-for="(faq, index) in faqs" :key="index" :title="faq.question" :name="index">
          <div class="faq-answer">{{ faq.answer }}</div>
        </el-collapse-item>
      </el-collapse>
    </div>

    <!-- Contact Information -->
    <div class="cooperation-section contact-info-section">
      <h2 class="section-title">联系我们</h2>
      
      <div class="contact-methods">
        <div class="contact-method">
          <div class="method-icon">
            <el-icon><Phone /></el-icon>
          </div>
          <div class="method-title">商务热线</div>
          <div class="method-content">400-888-9999</div>
        </div>
        
        <div class="contact-method">
          <div class="method-icon">
            <el-icon><Message /></el-icon>
          </div>
          <div class="method-title">商务邮箱</div>
          <div class="method-content">business@deepark.com</div>
        </div>
        
        <div class="contact-method">
          <div class="method-icon">
            <el-icon><Location /></el-icon>
          </div>
          <div class="method-title">公司地址</div>
          <div class="method-content">海南海口复兴城国家高新区</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive } from 'vue'
import { ElMessage, ElLoading } from 'element-plus'
import { 
  OfficeBuilding, 
  Van, 
  Connection, 
  DataAnalysis, 
  Shop,
  Phone,
  Message,
  Location
} from '@element-plus/icons-vue'
import { addInquiries } from '@/api/system/inquiries'
import { useRouter } from 'vue-router'

export default {
  name: 'BusinessCooperation',
  components: {
    OfficeBuilding, 
    Van, 
    Connection, 
    DataAnalysis, 
    Shop,
    Phone,
    Message,
    Location
  },

  setup() {
    const router = useRouter()

    // Cooperation types
    const cooperationTypes = [
      {
        id: 'parking_lot',
        title: '停车场合作',
        icon: 'OfficeBuilding',
        description: '接入您的停车场资源，提升管理效率与用户体验，实现智能化管理。'
      },
      {
        id: 'merchant',
        title: '商户合作',
        icon: 'Shop',
        description: '连接周边商户服务，为用户提供停车优惠，增加商户客流量。'
      },
      {
        id: 'vehicle',
        title: '车企合作',
        icon: 'Van',
        description: '深度整合车载系统，提供一站式停车导航、缴费、预约等服务。'
      },
      {
        id: 'tech',
        title: '技术合作',
        icon: 'Connection',
        description: '开放API接口，实现系统对接，共同开发智慧停车解决方案。'
      },
      {
        id: 'data',
        title: '数据合作',
        icon: 'DataAnalysis',
        description: '共享停车大数据，助力城市交通规划与商业选址决策。'
      }
    ]
    
    // Benefits
    const benefits = [
      {
        title: '海量用户资源',
        description: '接入DeePark平台，直接获取数百万活跃用户，快速拓展业务覆盖面。'
      },
      {
        title: '领先技术支持',
        description: '依托AI与大数据技术，提供智能化停车管理与精准营销解决方案。'
      },
      {
        title: '完善生态体系',
        description: '融入"车-位-人-商"生态圈，打造多元化商业价值与收益模式。'
      },
      {
        title: '专业运营团队',
        description: '一对一商务对接，提供全流程专业化运营与推广支持服务。'
      }
    ]
    
    // Case Studies
    const caseStudies = [
      {
        title: '商业综合体智慧停车解决方案',
        partner: '环球购物中心',
        // logo: 'https://placeholder.pics/svg/80x30/DEDEDE/555555/LOGO',
        image: 'https://test12346.oss-cn-shanghai.aliyuncs.com/case/20231130145036404850.png'
      },
      {
        title: '社区停车共享管理平台',
        partner: '和谐家园',
        // logo: 'https://placeholder.pics/svg/80x30/DEDEDE/555555/LOGO',
        image: 'https://test12346.oss-cn-shanghai.aliyuncs.com/case/%E6%9C%9B%E9%87%91%E6%B2%99%E5%B0%8F%E5%8C%BA%E6%97%A0%E4%BA%BA%E5%80%BC_1714375311000.jpg'
      },
      {
        title: '车企一体化停车服务',
        partner: '未来汽车',
        // logo: 'https://placeholder.pics/svg/80x30/DEDEDE/555555/LOGO',
        image: 'https://test12346.oss-cn-shanghai.aliyuncs.com/case/%E7%8F%A0%E6%B5%B7%E4%B8%AD%E4%BF%A1%E7%BA%A2%E6%A0%91%E6%B9%BE%E6%97%A0%E4%BA%BA%E5%80%BC%E5%AE%88%E6%99%BA%E6%85%A7%E5%81%9C%E8%BD%A6%E5%9C%BA_1714371326000.png'
      }
    ]
    
    // Form data
    const formData = reactive({
      company: '',
      name: '',
      position: '',
      phone: '',
      email: '',
      interest: '',
      description: ''
    })
    
    // Form validation rules
    const formRules = {
      company: [
        { required: true, message: '请输入公司名称', trigger: 'blur' }
      ],
      name: [
        { required: true, message: '请输入姓名', trigger: 'blur' }
      ],
      position: [
        { required: true, message: '请输入职位', trigger: 'blur' }
      ],
      phone: [
        { required: true, message: '请输入联系电话', trigger: 'blur' },
        { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
      ],
      email: [
        { required: true, message: '请输入电子邮箱', trigger: 'blur' },
        { type: 'email', message: '请输入正确的邮箱格式', trigger: 'blur' }
      ],
      interest: [
        { required: true, message: '请选择合作意向', trigger: 'change' }
      ]
    }
    
    // Contact form references
    const contactForm = ref(null)
    
    // Form submission
    const submitForm = () => {
      contactForm.value.validate((valid) => {
        if (valid) {
          // Create inquiry data object from form data
          const inquiryData = {
            company: formData.company,
            contactName: formData.name,
            position: formData.position,
            phone: formData.phone,
            email: formData.email,
            cooperationType: formData.interest,
            description: formData.description,
            source: 'website',
            status: 'pending'
          }

          // Show loading message
          const loading = ElLoading.service({
            lock: true,
            text: '提交中...',
            background: 'rgba(0, 0, 0, 0.7)'
          })

          // Call the API to submit the inquiry
          addInquiries(inquiryData).then(response => {
            loading.close()
            if (response.code === 200) {
              ElMessage.success('提交成功，我们将尽快与您联系')
              contactForm.value.resetFields()
            } else {
              ElMessage.error(response.msg || '提交失败，请稍后再试')
            }
          }).catch(error => {
            loading.close()
            console.error('提交咨询时出错:', error)
            ElMessage.error('提交失败，请稍后再试')
          })
        } else {
          ElMessage.error('请正确填写表单信息')
          return false
        }
      })
    }
    
    // FAQs
    const faqs = [
      {
        question: '如何成为DeePark的合作停车场？',
        answer: '您可以通过填写本页面的合作咨询表单，选择"停车场合作"，提交您的需求。我们的商务团队会在1-3个工作日内与您联系，了解具体情况并提供相应的合作方案。'
      },
      {
        question: '接入DeePark平台需要哪些技术条件？',
        answer: 'DeePark支持多种接入方式，包括API对接、SDK集成、硬件改造等。我们会根据您的具体情况提供最适合的技术方案，确保顺利接入。'
      },
      {
        question: '合作后能获得哪些数据分析和运营支持？',
        answer: 'DeePark提供专业的数据分析dashboard，包括客流分析、停车行为分析、收益分析等多维度报表。同时，我们的运营团队会提供定期的优化建议和营销活动支持。'
      },
      {
        question: '如何申请DeePark的开放API？',
        answer: '您可以选择"技术合作"类型提交申请，我们会评估您的需求并安排技术团队对接，提供相关的API文档和技术支持。'
      },
      {
        question: '商户如何在DeePark平台上提供停车优惠？',
        answer: '商户可以通过我们的商户合作计划，在平台上发布各类停车优惠活动，如免费停车、折扣停车等。这些优惠将精准推送给目标客户，提升到店率和消费转化。'
      }
    ]

    const goToCooperationPage = (type) => {
      const routeMap = {
        parking_lot: '/cooperation/parking-lot',
        merchant: '/cooperation/merchant',
        vehicle: '/cooperation/vehicle',
        tech: '/cooperation/tech',
        data: '/cooperation/data'
      }

      if (routeMap[type]) {
        router.push(routeMap[type])
      }
    }

    return {
      cooperationTypes,
      benefits,
      caseStudies,
      formData,
      formRules,
      contactForm,
      submitForm,
      goToCooperationPage,
      faqs
    }
  }
}
</script>

<style scoped>
.business-cooperation {
  background-color: #f5f7fa;
  min-height: 100vh;
}

.page-header {
  background-color: #fff;
  padding: 15px;
  position: sticky;
  top: 0;
  z-index: 10;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
}

.page-title {
  font-size: 16px;
  font-weight: 500;
}

/* Banner Styles */
.cooperation-banner {
  height: 200px;
  background-image: linear-gradient(to right, #1989fa, #5cadff);
  position: relative;
  overflow: hidden;
}

.banner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 30px;
  background-color: rgba(0, 0, 0, 0.2);
  color: white;
}

.banner-title {
  font-size: 28px;
  font-weight: bold;
  margin: 0 0 10px;
  line-height: 1.2;
}

.banner-subtitle {
  font-size: 16px;
  margin: 0;
  opacity: 0.9;
}

/* Section Styles */
.cooperation-section {
  padding: 20px 15px;
  margin-bottom: 15px;
  background-color: #fff;
}

.section-title {
  font-size: 18px;
  font-weight: 500;
  margin: 0 0 20px;
  color: #303133;
  text-align: center;
}

/* Cooperation Types Styles */
.cooperation-types {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 15px;
}

.type-card {
  text-align: center;
  border-radius: 8px;
}

.type-icon {
  font-size: 36px;
  color: #409EFF;
  margin-bottom: 10px;
}

.type-title {
  font-size: 15px;
  font-weight: 500;
  margin: 0 0 5px;
}

.type-desc {
  font-size: 12px;
  color: #606266;
  margin: 0;
  line-height: 1.4;
}

/* Benefits Styles */
.benefits-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.benefit-item {
  display: flex;
  align-items: flex-start;
}

.benefit-number {
  width: 28px;
  height: 28px;
  background-color: #409EFF;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  margin-right: 15px;
  flex-shrink: 0;
}

.benefit-title {
  font-size: 16px;
  font-weight: 500;
  margin: 0 0 5px;
}

.benefit-desc {
  font-size: 14px;
  color: #606266;
  margin: 0;
  line-height: 1.5;
}

/* Case Studies Styles */
.case-card {
  height: 100%;
  background-size: cover;
  background-position: center;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
}

.case-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom, rgba(0,0,0,0.1), rgba(0,0,0,0.7));
  display: flex;
  align-items: flex-end;
  padding: 15px;
}

.case-content {
  color: white;
}

.case-logo {
  margin-bottom: 10px;
}

.partner-logo {
  max-width: 80px;
  height: auto;
}

.case-title {
  font-size: 16px;
  font-weight: 500;
  margin: 0 0 5px;
}

.case-partner {
  font-size: 14px;
  opacity: 0.8;
}

/* Form Styles */
.form-subtitle {
  text-align: center;
  font-size: 14px;
  color: #606266;
  margin: -10px 0 20px;
}

.contact-form {
  max-width: 600px;
  margin: 0 auto;
}

.submit-button {
  width: 100%;
  height: 44px;
  font-size: 16px;
}

/* FAQ Styles */
.faq-answer {
  color: #606266;
  font-size: 14px;
  line-height: 1.5;
  padding: 10px;
}

/* Contact Info Styles */
.contact-methods {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  gap: 20px;
  margin-top: 15px;
}

.contact-method {
  flex: 1;
  min-width: 150px;
  text-align: center;
  padding: 15px;
  border-radius: 8px;
  background-color: #f5f7fa;
}

.method-icon {
  font-size: 36px;
  color: #409EFF;
  margin-bottom: 10px;
}

.method-title {
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 5px;
}

.method-content {
  font-size: 14px;
  color: #606266;
}
</style> 